import UIModels from './UI.models';
import FaqModels from './Faq.models';

const AppModel = {
	UI: UIModels,
	Faq: FaqModels
};

export default AppModel;
